import Markup from './markups';

export default Markup;
